const KEY = 'education:k12-teacher-handoff'
const MAX_AGE = 120000
const HEX = /^[a-f0-9]{64}$/
const ERROR = 'K12 giriş aktarımı doğrulanamadı. Lütfen yeniden giriş yapın.'
export const K12_WEB_CALLBACK = process.env.REACT_APP_K12_WEB_CALLBACK_URL || 'https://www.okudemi.co/app/'

function trustedCallback(value: string) {
  const url = new URL(value)
  const configured = new URL(K12_WEB_CALLBACK)
  const production = ['https://www.okudemi.co', 'https://okudemi.co'].includes(url.origin)
  const local = process.env.NODE_ENV !== 'production' && url.origin === configured.origin &&
    ['localhost', '127.0.0.1'].includes(url.hostname) && ['http:', 'https:'].includes(url.protocol)
  if ((!production && !local) || url.username || url.password || url.hash || url.search ||
      url.pathname.replace(/\/$/, '') !== '/app') throw new Error(ERROR)
  return url
}

export function k12WebEntry(authorizeUrl: string) {
  const authorize = new URL(authorizeUrl)
  if (authorize.origin !== 'https://api.k12net.com' || authorize.pathname !== '/GWCore.Web/connect/authorize' ||
      authorize.username || authorize.password || authorize.searchParams.get('response_type') !== 'code' ||
      !authorize.searchParams.get('client_id')) throw new Error(ERROR)
  const callback = trustedCallback(authorize.searchParams.get('redirect_uri') || '')
  callback.searchParams.set('k12_start', '1')
  return callback.toString()
}

const randomHex = () => Array.from(crypto.getRandomValues(new Uint8Array(32)), value => value.toString(16).padStart(2, '0')).join('')

export async function beginTeacherHandoff(params: URLSearchParams, storage: Storage) {
  const request = params.get('request') || ''
  if (params.getAll('request').length !== 1 || !/^[a-f0-9-]{36}$/.test(request) ||
      params.getAll('callbackOrigin').length !== 1) throw new Error(ERROR)
  const callback = trustedCallback(new URL('/app/', params.get('callbackOrigin') || '').toString())
  const verifier = randomHex()
  const state = randomHex()
  const challenge = Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))), value => value.toString(16).padStart(2, '0')).join('')
  storage.setItem(KEY, JSON.stringify({verifier, state, createdAt: Date.now()}))
  callback.search = new URLSearchParams({k12_teacher: '1', request, state, challenge}).toString()
  return callback.toString()
}

export function consumeTeacherHandoff(hash: string, storage: Storage) {
  const params = new URLSearchParams(hash.replace(/^#/, ''))
  const raw = storage.getItem(KEY)
  storage.removeItem(KEY)
  let pending
  try { pending = JSON.parse(raw || 'null') } catch { throw new Error(ERROR) }
  const ticket = params.get('ticket') || ''
  if (!pending || params.getAll('ticket').length !== 1 || params.getAll('state').length !== 1 ||
      !HEX.test(ticket) || !HEX.test(pending.verifier || '') || !HEX.test(pending.state || '') ||
      params.get('state') !== pending.state || !Number.isFinite(pending.createdAt) ||
      Date.now() - pending.createdAt > MAX_AGE || Date.now() < pending.createdAt) throw new Error(ERROR)
  return {ticket, verifier: pending.verifier as string}
}
